module.exports = __webpack_public_path__ + "media/images/logo-1ac05e55a23c9d1d8319e8ec752b8f98.svg";